export const DeLocale = {
    page: {
        txtTitle: 'SHIRITORI | Japanischen Wortschatz online mit dem spaßigen Spiel しらとり lernen',
    },
    common: {
        txtLogoAlt: 'Shiritori-Zug',
    },
    header: {
        txtLeave: 'SPIEL VERLASSEN',
    },
    dialog: {
        leave: {
            txtTitle: 'Dieses Spiel verlassen?',
            btnStay: 'IM SPIEL BLEIBEN',
            btnLeave: 'VERLASSEN UND AUFGEBEN',
        },
    },
    home: {
        btnNewGame: 'NEUES SPIEL',
        btnMainMenu: 'HAUPTMENÜ',
        btnJoinGame: 'BEITRETEN',
        btnReturnToGame: 'ZURÜCK ZUM SPIEL',
    },
    create: {
        headingNamePrompt: 'Wie sollen wir dich nennen?',
        placeholderName: 'Dein Name',
        btnOk: 'OK',
    },
    join: {
        placeholderName: 'Dein Name',
        placeholderGameId: 'Spiel-ID',
        btnJoinGame: 'BEITRETEN',
    },
    configure: {
        header: 'SPIELEINSTELLUNG',
        labelExpectedPlayers: 'Anzahl der Spieler',
        labelBoardSize: 'Spielfeldgröße',
        labelWordList: 'Wortliste',
        labelAllowHints: 'Hinweise erlauben',
        labelTurnTimer: 'Zugtimer',
        optionNoTimer: 'Kein Timer',
        optionTimer: 'Timer',
        unitSeconds: 'Sek.',
        btnStartGame: 'STARTEN',
        toastCreateError: 'Fehler: Dieses Spiel kann nicht erstellt werden',
        toastTryAgain: 'Fehler: Bitte später erneut versuchen.',
    },
    game: {
        lobby: {
            btnReady: 'Bereit',
            txtShareInvite: 'Teile diesen Code mit deinen Freunden!',
            txtPlayer: 'Spieler',
            txtTeam: 'Team',
        },
        message: {
            noSuchGame: 'Dieses Spiel existiert nicht',
            txtLoading: 'Lädt...',
            txtCannotJoin: 'Beitritt zum Spiel nicht möglich',
        },
        gameplay: {
            board: {
                timeoutTitle: 'ZEIT',
                timeoutSubtitle: 'abgelaufen',
            },
            wordSearch: {
                multipleMatches: 'MEHRERE TREFFER GEFUNDEN!',
                yourTurn: 'DU BIST DRAN',
                placeholder: 'Welches Wort spielen wir?',
                playAction: 'SPIELEN',
                timerSeconds: '{{seconds}}s',
                toastNoSuchWord: 'Kein solches Wort!',
                toastCantPlay: 'Dieses Wort kann nicht gespielt werden!',
                toastPlayed: '"{{word}}" gespielt',
                toastPlayFailed: 'Ups, dieses Wort konnte nicht gespielt werden!',
                validation: {
                    syllableMismatch: 'Anfangssilbe passt nicht',
                    missingLastWord: 'Im letzten Zug fehlt ein Wort',
                    wordNotInList: 'Wort ist nicht in der Liste',
                }
            },
            spectate: {
                waitingOn: 'Warte auf {{player}}',
                timeLeft: 'Verbleibende Zeit: {{seconds}}s',
            },
            endGame: {
                header: 'SPIEL BEENDET',
                viewResults: 'ERGEBNISSE ANZEIGEN',
                statsTotalTime: 'Gesamtspielzeit',
                statsSquaresFilled: 'Gefüllte Felder',
                statsLongestWord: 'Längstes Wort',
                share: 'Teilen',
                sharing: 'Wird geteilt...',
                ariaCloseLabel: 'Spielende-Dialog schließen',
            }
        },
    },
    footer: {
        linkHowToPlay: 'So geht’s',
        linkPrivacyPolicy: 'Datenschutzerklärung',
        txtAllRightsReserved: 'Alle Rechte vorbehalten.',
    },
    howToPlay: {
        title: 'So spielst du Shiritori しりとり (shiritori)',
        btnPlayNow: 'Jetzt spielen!',
        btnReturnToGame: 'Zurück zum Spiel:',
        description1: 'b|Shiritori| ist unsere Online-Mehrspieler-Version des japanischen Wortketten-Spiels しりとり. Baue ein Bild-Board auf und übe dabei Wortschatz mit Freunden oder solo.',
        description2: 'Erstelle oder betrete ein Spiel, wähle Boardgröße, Bildset und Wortliste und fülle dann das Raster mit gültigen Wörtern, bevor jemand einen Fehler macht.',
        gameSetup: {
            title: 'Spiel erstellen oder beitreten',
            p1: 'Starte allein oder lade bis zu 9 Freunde ein (insgesamt 10 Spieler) über einen teilbaren Link oder Spielcode.',
            p2: 'Wähle deine Optionen: Boardgröße (3x3, 5x5, 7x7), Hintergrundmuster/-farbe, Bildset und die Wortliste zum Lernen.',
            p3: 'Freunde öffnen den Link, wählen einen Nickname und erscheinen in der Lobby; das Spiel startet, sobald die erwartete Spielerzahl erreicht ist.',
            p4: 'Späte Teilnehmer können ein laufendes Match weiterhin im Nur-Zuschauen-Modus verfolgen.',
        },
        objective: {
            title: 'Ziel',
            p1: 'Bilde Wortketten, sodass jedes neue Wort mit der letzten Silbe des vorherigen beginnt, fülle das Board und beende niemals ein Wort mit ん.',
        },
        wordRules: {
            title: 'Gültige Wörter',
            p1: 'Gib in Kana oder Romaji ein; Romaji wird clientseitig vor der Prüfung in Hiragana umgewandelt.',
            p2: 'Wörter müssen in der gewählten Liste enthalten sein (100/1000 häufige Wörter, Essen, Sport usw.) und zeigen nach dem Spielen ihre Bedeutung.',
            p3: 'Bereits genutzte Wörter sind gesperrt. Wenn Homophone erlaubt sind, kannst du eine ungenutzte Variante mit passendem Bild wählen.',
            li1: 'Beginnt mit der geforderten Silbe aus dem vorherigen Zug',
            li2: 'Endet nicht mit ん (n)',
            li3: 'Ist in der gewählten Wortliste enthalten',
            li4: 'Wurde in diesem Spiel noch nicht gespielt',
            li5: 'Verwendet ein erlaubtes Homophon/Bild, wenn diese Regel aktiv ist',
            p4: 'Jeder gültige Zug setzt sein Bild der Reihenfolge nach ins Board und füllt es von links nach rechts, oben nach unten. e|Beispiel:_そば_→_バス|',
        },
        turnFlow: {
            title: 'Züge und Timing',
            p1: 'Die Züge rotieren durch die Spielerliste; sobald du aktiv bist, hast du bis zu 10 Sekunden ab dem Moment, in dem du deinen Zug siehst.',
            p2: 'Shiritori wartet, bis der nächste Spieler aktiv ist (Browser im Fokus), bevor der Countdown startet. So kann der Timer nicht durch Neustart oder Reload umgangen werden.',
            p3: 'Gib dein Wort ein, beobachte die Live-Validierung und sende vor Ablauf ab. Ungültige oder verspätete Eingaben beenden das Match sofort.',
        },
        boardFlow: {
            title: 'Board, Ablauf und Ende',
            p1: 'Das Board zeigt jedes gespielte Wort mit Bild, Spielernamen und Zugnummer; Pfeile markieren die Reihenfolge im Raster.',
            p2: 'Wenn jemand anderes dran ist, siehst du trotzdem die benötigte Anfangssilbe und den Countdown.',
            p3: 'Sind alle Felder mit gültigen Wörtern gefüllt, endet das Spiel erfolgreich und zeigt das vollständige Board zum Teilen.',
            p4: 'Wird vor Ablauf keine gültige Eingabe abgeschickt, endet das Spiel mit einer Zusammenfassung, wer die Zeit überschritten oder ein ungültiges Wort gespielt hat.',
        },
        summary: {
            title: 'Zusammenfassung',
            p1: 'Shiritori hält Shiritori schnell und visuell: kurze Runden, klare Regeln und Bildmerkhilfen helfen allen, die Kette am Leben zu halten.',
            p2: 'Teile einen Link, fülle das Board und schau, wie lange deine Wortkette durchhält.',
        }
    },
    bugsAndFeatures: {
        title: 'Bugmeldungen und neue Features',
        p1: 'Wir haben dieses Spiel als andere Art gebaut, das klassische k|しりとり.| zu spielen. Als Team, das Spiele liebt, suchen wir immer nach Wegen, es besser und unterhaltsamer zu machen.',
        cta: {
            l1: 'Wir würden uns freuen, wenn du uns hilfst, indem du ',
            a: 'unser Spiel mit deinen Freunden teilst',
            l2: ' auf Social Media!'
        },
        p2: 'Wenn du Bugs findest oder Vorschläge für neue Funktionen hast, sag uns bitte Bescheid!',
        bugs: {
            title: 'Bugs',
            p1: 'Bitte melde seltsames Verhalten, Fehler oder Bugs direkt in unserem öffentlichen a|https://github.com/indexinteractive/|GitHub_Repository| . Gib möglichst viele Details an, einschließlich der Schritte zur Reproduktion.'
        },
        features: {
            title: 'Neue Features',
            p1: 'Wenn du Ideen für neue Funktionen, Verbesserungen oder das Spiel hast, erstelle bitte eine neue Diskussion auf unserer a|https://github.com/indexinteractive/|GitHub_Discussions|-Seite.'
        }
    },
    share: {
        title: 'Shiritori | Japanischen Wortschatz online mit dem spaßigen Spiel しらとり lernen - SHIRITORI',
        text: 'Spiele Shiritori online mit Freunden oder zufälligen Spielern. Keine Registrierung nötig!',
    }
};
